var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_866_6913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7225 6H14.2575V7.5H8.7225V6Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6H7.6425V7.5H5.25V6Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12H10.785V13.5H5.25V12Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8575 12H14.25V13.5H11.8575V12ZM5.25 9H12V10.5H5.25V9Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0C4.365 0 0 4.365 0 9.75C0 15.135 4.365 19.5 9.75 19.5C15.135 19.5 19.5 15.135 19.5 9.75C19.5 7.16414 18.4728 4.68419 16.6443 2.85571C14.8158 1.02723 12.3359 0 9.75 0ZM9.75 18C5.19375 18 1.5 14.3062 1.5 9.75C1.5 5.19375 5.19375 1.5 9.75 1.5C14.3062 1.5 18 5.19375 18 9.75C18 14.3062 14.3062 18 9.75 18ZM16.9357 17.9947L17.9963 16.9342L23.7772 22.7152L22.7167 23.7757L16.9357 17.9947Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_866_6913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioIcon);
export default __webpack_public_path__ + "static/media/bio_icon.ac16faba49153032558c4b22d943e08f.svg";
export { ForwardRef as ReactComponent };